import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from '../services';
import Loader from '../../../commons/loader';
import { PaginationTotal } from '../../../commons/controls';
import NetworkEmptyState from '../../../commons/networkemptystate';
import DataEmptyState from '../../../commons/dataemptystate';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import Lib from '../../../commons/lib';
import ProgressButton from '../../../commons/ProgressButton';

class BufeLista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bufek: [],
      bufeModositObj: {},
      dataLoaded: false,
      dataFailed: false,
      raktarLoading: false,
      modalBufe: false,
      modalBufeModosit: false,
      modalBufeTorles: false,
      raktarak: [],
      raktar: null,
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      existsNaptar: false,
      helyszinOptions: [],
      naptarEsemenyOptions: [],
      helyszinid: null,

      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  getRaktarak = () => {
    Service.getRaktars('', (err, res) => {
      if (!err) {
        this.setState({
          raktarak: res[0],
          raktar: ((res[0]?.length > 0 ) ? res[0][0] : null)
        });
      }
    })
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.updateTable();
      }
    }
  }

  hasRoleKarb = () => {
    if (this.props.globals.hasRole(['BUFE_BUFE'], true)) return true;
    return false;
  }

  raktarValaszto = () => {
    return (
      <SelectField
        name="raktarvalaszto"
        id="raktarvalaszto"
        placeholder="Válassz raktárat..."
        noOptionsMessage={() => 'Nincs keresési eredmény'}
        searchPromptText="Kezdj el gépelni a kereséshez..."
        loadingMessage={() => 'Keresés...'}
        isClearable
        ignoreAccents={false}
        isLoading={this.state.raktarLoading}
        value={this.state.raktar}
        onInputChange={_.debounce(this.handleInputRaktarChange, 1000)}
        onChange={this.handleRaktarChange}
        options={this.state.raktarak}
        getOptionLabel={option => option.nev}
        getOptionValue={option => option.id}
      />
    );
  }

  handleRaktarChange = (raktar) => {
    if (raktar) {
      this.setState({ raktar: raktar });
    } else {
      this.setState({ raktar: null });
    }
  }

  handleInputRaktarChange = (value, { action }) => {
    switch (action) {
      case 'input-change':
        if (value && value.length > 2) {
          this.setState({ raktarLoading: true });
          Service.getRaktars(value, (err, res) => {
            if (!err) {
              this.setState({
                raktars: res[0],
                raktarLoading: false
              });
            }
          });
        }
        break;
      default:
    }
  }

    handleHelyszinChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      Service.getNaptarEsemenyTipusByHelyszin(value, (err, res) => {
        if (!err) {
          let naptarEsemenyOptions = res[0] && res[0].map(n => (<option key={n[0]} value={n[0]}>{n[1]}</option>));
          this.setState({
            naptarEsemenyOptions: naptarEsemenyOptions,
            helyszinid: value
          });
        }
      });
    } else {
      this.setState({
        naptarEsemenyOptions: [],
        helyszinid: null
      });
    }
  }

  handleNaptarTipusOnModifyChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    let bufe = this.state.bufeModositObj;
    if (value) {
      bufe.naptaresemenytipusazonosito = value;
    } else {
      bufe.naptaresemenytipusazonosito = null;
    }

    this.setState({ bufeModositObj: bufe });
  }

  checkRaktar = () => {
    if (!this.state.raktar) {
      this.props.globals.addError('Raktár választása kötelező!');
      return false;
    }
    return true;
  }

  updateTable = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Service.listBufek((err, res) => {
        if (!err) {
          if (res[0].length > 0) {
            this.setState({ bufek: res[0], tableStatus: 'TABL' });
          } else {
            this.setState({ tableStatus: 'DATA' });
          }
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  toggleBufe = () => {
    this.setState((prevState) => { return ({ modalBufe: !prevState.modalBufe, raktar: null, raktars: [] }); });
  }

  toggleBufeModosit = () => {
    this.setState((prevState) => { return ({ modalBufeModosit: !prevState.modalBufeModosit }); });
  }

  toggleBufeTorles = () => {
    this.setState((prevState) => { return ({ modalBufeTorles: !prevState.modalBufeTorles }); });
  }

    handleBufeNewClick = () => {
    Service.initBufeForm(false, null, (err, res) => {
      if (!err) {
        let helyszinOptions = res[0].helyszin && res[0].helyszin.map(e => (<option key={e.id} value={e.id}>{e.nev}</option>));
        this.setState({
          existsNaptar: res[0].existsnaptar,
          helyszinOptions: helyszinOptions,
          bufeModositObj: {},
          helyszinid: ((res[0].helyszin?.length > 0 ) ? res[0].helyszin[0].id : null)
        });

        /* if(res[0].helyszin?.length === 1) {
          this.setState({ helyszinid: res[0].helyszin[0].id });
        } */
      }
    });
    this.getRaktarak();
    this.toggleBufe();
  }

   handleBufeEditClick = (id) => {
    Service.initBufeForm(true, id, (err, res) => {
      if (!err) {
        this.setState(() => {
          const bufe = res[0].bufe;
          Service.getNaptarEsemenyTipusByHelyszin(bufe.helyszinid, (err, res1) => {
            if (!err) {
              let naptarArray = [];
              let naptarEsemenyOptions = res1[0] && res1[0].map((n) => {
                naptarArray.push(n[0]);
                return (<option key={n[0]} value={n[0]}>{n[1]}</option>);
              });

              if (!naptarArray.includes(bufe.naptaresemenytipusazonosito)) {
                bufe.naptaresemenytipusazonosito = null;
                bufe.naptaresemenytipusnev = null;
              }

              this.setState({
                naptarEsemenyOptions: naptarEsemenyOptions,
                helyszinid: bufe.helyszinid
              });
            }
          });
          return ({ existsNaptar: res[0].existsnaptar, bufeModositObj: bufe });
        });
      }
    });

    this.toggleBufeModosit();
  }

  handleBufeDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleBufeTorles();
  }

  /**
  * Visszaadja a büféhez tartozó művelet gombokat.
  * @param {string} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Módosítás, törlés gombokat tartalmazó react objektum.
  */
  iconFormatter = (cell) => {
    return (
      <div>
        {
          this.hasRoleKarb()
            ? (
              <div>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleBufeEditClick(cell)} />
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleBufeDeleteClick(cell)} />
              </div>
            )
            : <div />
        }
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
      </div>
    );
  }

  addBufe = (event, bufeObj) => {
    if (this.checkRaktar()) {
      bufeObj.raktarid = this.state.raktar.id;
      this.setState({ addButtonLoading: true });
      Service.addBufe(bufeObj, (err) => {
        if (!err) {
          this.toggleBufe();
          this.updateTable();
          this.props.globals.addSuccess('Büfé hozzáadva!');
        }
        this.setState({ addButtonLoading: false });
      });
    }
  }

  modifyBufe = (event, bufeModositObj) => {
    this.state.bufeModositObj.nev = bufeModositObj.nev;
    this.state.bufeModositObj.azonosito = bufeModositObj.azonosito;
    this.setState({ modifyButtonLoading: true });
    Service.editBufe(this.state.bufeModositObj, (err) => {
      this.updateTable();
      if (!err) {
        this.toggleBufeModosit();
        this.props.globals.addSuccess('Büfé módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteBufe = () => {
    this.toggleBufeTorles();
    this.setState({ deleteButtonLoading: true });
    Service.deleteBufe(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Büfé törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'kod',
        text: 'Kód',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'raktarnev',
        text: 'Raktár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'helyszinnev',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'naptaresemenytipusnev',
        text: 'Naptár eseménytípus',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      }
    ];

    const columns2 = [
      ...columns,
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.bufek}
        columns={this.hasRoleKarb() ? columns2 : columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  renderState = () => {
    if (this.state.tableStatus === 'NETW') {
      return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
    } if (this.state.tableStatus === 'DATA') {
      return <DataEmptyState hasImage />;
    } if (this.state.tableStatus === 'TABL') {
      return this.renderTable();
    } if (this.state.tableStatus === 'LOAD') {
      return <Loader />;
    }
  }

  /**
   * React render.
   * @return {ReactElement} Termékcsoport modul.
   */
  render() {
    return (
      <div>
        <div className="row">
          {
            this.hasRoleKarb()
              ? (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.handleBufeNewClick}>Új büfé</Button>
                </div>
              )
              : <div />
          }
        </div>
        {this.renderState()}
        <Modal isOpen={this.state.modalBufe} toggle={this.toggleBufe} className={this.props.className} backdrop="static">
          <RFForm
              modal
              title="Büfé felvétel"
              onSubmit={this.addBufe}
              footer={
                <React.Fragment>
                  <ProgressButton loading={this.state.addButtonLoading} color="primary">Hozzáadás</ProgressButton>{' '}
                  <Button type="button" color="secondary" onClick={this.toggleBufe}>Mégsem</Button>
                </React.Fragment>
              }
            >
              <RFField
                label="Kód: *"
                name="kod"
                // validate={{
                //   maxLength: { value: 5 }
                // }}
                maxLength={5}
                required
              />
              <RFField
                label="Büfé neve: *"
                name="nev"
                // validate={{
                //   maxLength: { value: 30 }
                // }}
                maxLength={30}
                required
              />
              <div style={{ paddingTop: 10 }}>
                <Label for="raktadId">Raktár: *</Label>
                {this.raktarValaszto()}
              </div>
              <div style={{ paddingTop: 10 }}>
                <RFField
                  type="select"
                  name="helyszinid"
                  label="Helyszín: *"
                  errorMessage="Kötelező mező!"
                  value={this.state.helyszinid}
                  onChange={this.handleHelyszinChange}
                  defaultSelect={<option value="">{'Válassz helyszínt...'}</option>}
                  selectOptions={this.state.helyszinOptions}
                />
              </div>
              {this.state.existsNaptar && (
                <div>
                  <RFField
                    type="select"
                    name="naptaresemenytipusazonosito"
                    label="Naptár eseménytípus:"
                    errorMessage="Kötelező mező!"
                    disabled={!this.state.helyszinid}
                    defaultSelect={<option value="">{'Válassz eseménytípust...'}</option>}
                    selectOptions={this.state.naptarEsemenyOptions}
                  />
                </div>
              )}
           </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalBufeModosit} toggle={this.toggleBufeModosit} className={this.props.className} backdrop="static">
          <RFForm
            modal
            title="Büfé módosítás"
            onSubmit={this.modifyBufe}
            footer={
              <React.Fragment>
                <ProgressButton loading={this.state.modifyButtonLoading} className="btn-cursor-pointer" color="primary">Mentés</ProgressButton>{' '}
                <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleBufeModosit}>Mégsem</Button>
              </React.Fragment>
            }
          >
            <RFField
              label="Büfé neve: *"
              name="nev"
              value={this.state.bufeModositObj.nev}
              // validate={{
              //   maxLength: { value: 30 }
              // }}
              maxLength={30}
              required
            />
            {this.state.existsNaptar && (
                <div>
                  <RFField
                    type="select"
                    name="naptaresemenytipusazonosito"
                    label="Naptár eseménytípus:"
                    errorMessage="Kötelező mező!"
                    value={this.state.bufeModositObj.naptaresemenytipusazonosito}
                    onChange={this.handleNaptarTipusOnModifyChange}
                    defaultSelect={<option value="">{'Válassz eseménytípust...'}</option>}
                    selectOptions={this.state.naptarEsemenyOptions}
                  />
                </div>
              )}
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalBufeTorles} toggle={this.toggleBufeTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a büfét?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} color="primary" onClick={this.deleteBufe}>OK</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleBufeTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default BufeLista;
